import { createFormContext } from "@mantine/form";
import { zTopicLike } from "shared/graphql/topics";
import { Language, OptInUserQuery } from "src/gql/graphql";
import { CmSchema, LanguageSchema } from "src/gql/zod";
import z from "zod";

const zOptInUserState = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    language: LanguageSchema.default(Language.English),
    euds: z
        .object({
            id: z.string(),
            type: CmSchema,
            value: z.string(),
            isVerified: z.boolean(),
        })
        .array()
        .default([]),
    topics: zTopicLike.array().default([]),
    customer: z.object({
        id: z.string(),
        name: z.string(),
        languages: LanguageSchema.array(),
    }),
    durationDays: z.string().default("forever"),
    agreedToPrivacyPolicy: z.boolean().default(false),
    agreedToTOS: z.boolean().default(false),
    meta: z
        .object({
            step: z.number().default(0),
        })
        .default({}),
});

type OptInUserState = z.infer<typeof zOptInUserState>;

export const [OptInUserFormProvider, useOptInUserFormContext, useOptInUserForm] = createFormContext<OptInUserState>();

export function createOptInUserFormState(data: {
    user?: OptInUserQuery["user"];
    customer: { id: string; name: string; languages: Language[] };
}): OptInUserState {
    return zOptInUserState.parse({
        ...data.user,
        customer: data.customer,
        name: data.user?.name ?? undefined,
        topics: data.user?.topics.map((it) => ({ ...it, description: it.description ?? undefined })),
    });
}
